<template>
	<div>
		<a-page-header style="background: #fff;" title="同城信息管理" :breadcrumb="{props:{routes:[{breadcrumbName:'首页'},{breadcrumbName:'同城信息管理'}]}}">
			<template slot="extra">
				<a-button type="primary" @click="addModal = true">
					添加同城信息
				</a-button>
			</template>
			<a-form-model layout="inline" :form="searchForm" @submit="searchSubmit">
				<a-form-model-item>
					<a-input-group compact>
						<a-select style="width: 120px" v-model="searchForm.type">
							<a-select-option :value="1">信息名称</a-select-option>
							<a-select-option :value="2">联系电话</a-select-option>
						</a-select>
						<a-input style="width: 300px" placeholder="请输入内容" v-model="searchForm.word" />
					</a-input-group>
				</a-form-model-item>
				<a-form-model-item>
					<a-select style="width: 300px" v-model="searchForm.cityinfoClass" placeholder="所属分类" :options="cityinfoClassList"></a-select>
				</a-form-model-item>
				<a-form-model-item>
					<a-button type="primary" html-type="submit">
						搜索
					</a-button>
				</a-form-model-item>
			</a-form-model>
		</a-page-header>

		<!-- 列表 -->
		<div class="mainBox">
			<div class="contentBox">
				<a-table :columns="columns" :dataSource="list" rowKey="id" :pagination="pagination" :loading="loading" @change="handleTableChange">
					<span slot="cityinfoClass" slot-scope="cityinfoClass">
						<a-tag color="blue">{{cityinfoClass}}</a-tag>
					</span>
					<span slot="cityinfoStatus" slot-scope="cityinfoStatus">
						<a-tag v-if="cityinfoStatus == true" color="green">显示</a-tag>
						<a-tag v-if="cityinfoStatus == false" color="red">隐藏</a-tag>
					</span>
					<span slot="action" slot-scope="text, record">
						<a @click="toDetail(record.id)">详情</a>
						<a-divider type="vertical" />
						<a-popconfirm title="请确认是否删除？" okText="是" cancelText="否" @confirm="del(record.id)">
							<a href="javascript:;" style="color: #ff4d4f;">删除</a>
						</a-popconfirm>
					</span>
				</a-table>
			</div>
		</div>

		<!-- 添加同城信息弹出 -->
		<a-modal title="添加同城信息" v-model="addModal" @ok="addSubmit" cancelText="取消" okText="添加" width="50%">
			<a-form-model ref="addForm" :model="addForm" :rules="addRules" :label-col="{ span: 5 }" :wrapper-col="{ span: 14 }">
				<a-form-model-item label="信息名称" prop="cityinfoName">
					<a-input v-model="addForm.cityinfoName" />
				</a-form-model-item>
				<a-form-model-item label="信息分类" prop="cityinfoClass">
					<a-select v-model="addForm.cityinfoClass" :options="cityinfoClassList">
					</a-select>
				</a-form-model-item>
				<a-form-model-item label="联系电话" prop="cityinfoTel">
					<a-input v-model="addForm.cityinfoTel" />
				</a-form-model-item>
				<a-form-model-item label="信息内容" prop='cityinfoContent'>
					<a-textarea v-model="addForm.cityinfoContent" :auto-size="{ minRows: 3}" />
				</a-form-model-item>
				<a-form-model-item label="是否显示" prop='cityinfoStatus'>
					<a-switch checked-children="显示" un-checked-children="隐藏" v-model="addForm.cityinfoStatus" />
				</a-form-model-item>
			</a-form-model>
		</a-modal>

		<!-- 修改同城信息弹出 -->
		<a-modal title="编辑同城信息" v-model="editModal" @ok="editSubmit" cancelText="取消" okText="保存" width="50%">
			<a-form-model ref="editForm" :model="editForm" :rules="addRules" :label-col="{ span: 5 }" :wrapper-col="{ span: 14 }">
				<a-form-model-item label="信息名称" prop="cityinfoName">
					<a-input v-model="editForm.cityinfoName" />
				</a-form-model-item>
				<a-form-model-item label="信息分类" prop="cityinfoClass">
					<a-select v-model="editForm.cityinfoClass" :options="cityinfoClassList">
					</a-select>
				</a-form-model-item>
				<a-form-model-item label="联系电话" prop="cityinfoTel">
					<a-input v-model="editForm.cityinfoTel" />
				</a-form-model-item>
				<a-form-model-item label="信息内容" prop='cityinfoContent'>
					<a-textarea v-model="editForm.cityinfoContent" :auto-size="{ minRows: 3}" />
				</a-form-model-item>
				<a-form-model-item label="是否显示" prop='cityinfoStatus'>
					<a-switch checked-children="显示" un-checked-children="隐藏" v-model="editForm.cityinfoStatus" />
				</a-form-model-item>
			</a-form-model>
		</a-modal>
	</div>
</template>

<script>
	var storage = window.localStorage
	const columns = [{
			title: 'ID',
			dataIndex: 'id',
		},
		{
			title: '信息名称',
			dataIndex: 'cityinfoName',
			scopedSlots: {
				customRender: 'cityinfoName'
			},
		},
		{
			title: '信息分类',
			dataIndex: 'cityinfoClass',
			scopedSlots: {
				customRender: 'cityinfoClass'
			},
		},
		{
			title: '联系电话',
			dataIndex: 'cityinfoTel',
			scopedSlots: {
				customRender: 'cityinfoTel'
			},
		},
		{
			title: '显示状态',
			dataIndex: 'cityinfoStatus',
			scopedSlots: {
				customRender: 'cityinfoStatus'
			},
		},
		{
			title: '操作',
			dataIndex: 'action',
			scopedSlots: {
				customRender: 'action'
			},
		},
	];

	export default {
		data() {
			return {
				columns,
				list: [],
				cityinfoClassList: [],
				searchForm: {
					type: 1
				},
				pagination: {
					pageSize: 20,
					total: 0,
					current: 1
				},
				addForm: {
					cityinfoStatus: true
				},
				addModal: false,
				editForm: {},
				editModal: false,
				loading: false,
				addRules: {
					cityinfoName: [{
						required: true,
						message: '请填写信息名称',
						trigger: 'blur'
					}],
					cityinfoClass: [{
						required: true,
						message: '请选择信息分类',
						trigger: 'blur'
					}],
					cityinfoTel: [{
						required: true,
						message: '请填写联系电话',
						trigger: 'blur'
					}],
				},
			};
		},

		mounted() {
			this.getList()
			this.getCityinfoClassList()
		},

		methods: {
			toDetail(id) {
				this.classId = id
				this.$http.post('/admin/index.php/admin/News/cityControlInfo', {
					id: id
				}).then(res => {
					if (res.data.code == 1) {
						this.editForm = res.data.data
						this.editModal = true
					} else {
						this.$message.error(res.data.msg);
					}
				})
			},

			editSubmit() {
				this.$refs.editForm.validate(valid => {
					if (valid) {
						this.$http.post('/admin/index.php/admin/News/cityControlSave', {
							id: this.classId,
							cityinfoName: this.editForm.cityinfoName,
							cityinfoClass: this.editForm.cityinfoClass,
							cityinfoTel: this.editForm.cityinfoTel,
							cityinfoContent: this.editForm.cityinfoContent,
							cityinfoStatus: this.editForm.cityinfoStatus,
						}).then(res => {
							if (res.data.code == 1) {
								this.$message.success('保存成功！');
								this.editModal = false
								this.getList()
							} else {
								this.$message.error(res.data.msg);
							}
						})
					}
				});
			},

			addSubmit() {
				this.$refs.addForm.validate(valid => {
					if (valid) {
						this.$http.post('/admin/index.php/admin/News/cityControlSave', {
							cityinfoName: this.addForm.cityinfoName,
							cityinfoClass: this.addForm.cityinfoClass,
							cityinfoTel: this.addForm.cityinfoTel,
							cityinfoContent: this.addForm.cityinfoContent,
							cityinfoStatus: this.addForm.cityinfoStatus,
						}).then(res => {
							if (res.data.code == 1) {
								this.$message.success('添加成功！');
								this.addModal = false
								this.getList()
							} else {
								this.$message.error(res.data.msg);
							}
						})
					}
				});
			},

			del(id) {
				this.$http.post('/admin/index.php/admin/News/cityControlDel', {
					id: id
				}).then((res) => {
					if (res.data.code == 1) {
						this.$message.success(res.data.msg);
						this.getList();
					} else {
						this.$message.error(res.data.msg);
					}
				})
			},

			searchSubmit(e) {
				e.preventDefault()
				this.getList()
			},

			handleTableChange(pagination, filters, sorter) {
				this.list = []
				this.pagination.current = pagination.current
				this.pagination.field = sorter.field
				this.pagination.order = sorter.order
				this.getList()
			},

			getList() {
				this.loading = true
				var data = {
					page: this.pagination.current,
					num: this.pagination.pageSize,
					field: this.pagination.field,
					order: this.pagination.order,
					type: this.searchForm.type,
					word: this.searchForm.word,
					cityinfoClass: this.searchForm.cityinfoClass
				}
				this.$http.post('/admin/index.php/admin/News/cityControlList', data).then(res => {
					this.loading = false
					if (res.data.code == 1) {
						this.list = res.data.data
						this.pagination.total = res.data.count
					} else {
						this.$message.error(res.data.msg);
					}
				})
			},

			getCityinfoClassList() {
				this.$http.get('/admin/index.php/admin/News/cityInfoPullList').then(res => {
					if (res.data.code == 1) {
						this.cityinfoClassList = res.data.data
					}
				})
			}
		}
	}
</script>

<style scoped="">
	.ant-upload-select-picture-card i {
		font-size: 32px;
		color: #999;
	}

	.ant-upload-select-picture-card .ant-upload-text {
		margin-top: 8px;
		color: #666;
	}
</style>
